import { OAuth2 } from '@backstage/core-app-api';
import {
  AnyApiFactory,
  ApiRef,
  BackstageIdentityApi,
  configApiRef,
  createApiFactory,
  createApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
} from '@backstage/core-plugin-api';
import {
  ScmAuth,
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';

export const oidcAuthApiRef: ApiRef<
  OpenIdConnectApi & 
  ProfileInfoApi & 
  BackstageIdentityApi & 
  SessionApi 
> = createApiRef({
  id: 'keycloak',
});

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: oidcAuthApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) => {
      return OAuth2.create({
        discoveryApi,
        configApi,
        oauthRequestApi,
        provider: {
          id: 'keycloak',
          title: 'Keycloak',
          icon: () => null,
        },
        environment: configApi.getOptionalString('auth.environment'),
        defaultScopes: ['openid','profile','email'],
        popupOptions: {
          size: {
            fullscreen: true,
          },
        },
      });
    },
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => {
      return ScmIntegrationsApi.fromConfig(configApi);
    },
  }),
  ScmAuth.createDefaultApiFactory(),
];